import Vue from 'vue'
import {
    Pagination,
    Button,
    MessageBox,Message,
    Loading,
    Form,
    FormItem,
    Input,
    menu,
    Row,
    Col,
    card,
    MenuItem,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Badge,
    Submenu,
    MenuItemGroup,
    Tabs,
    TabPane,
    Table,TableColumn,Steps,Step,Tag,DatePicker,Link,Select,Option,
    OptionGroup,Switch,Checkbox,
    CheckboxButton,
    CheckboxGroup,
    Radio,
    RadioGroup,
    RadioButton,
    Dialog, Tree, Upload,
    Carousel,
  CarouselItem,
    Alert,
} from 'element-ui'
Vue.use(Pagination);
Vue.use(Button);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Loading);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(menu);
Vue.use(Row);
Vue.use(Col);
Vue.use(card);
Vue.use(MenuItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Badge);
Vue.use(Submenu);
Vue.use(MenuItemGroup);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Dialog);
Vue.use(Tag);
Vue.use(DatePicker);
Vue.use(Link);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Switch);
Vue.use(Tree);
Vue.use(Upload);
Vue.use(Alert);
Vue.use(Carousel);
Vue.use(CarouselItem);

//将message放到原型对象中
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$alert = MessageBox.alert;